<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
            prop="name"
          label="病种名称">
          <a-input placeholder="请输入病种名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
            prop="code"
          label="病种Code">
          <a-input placeholder="请输入病种Code" v-model="model.code" />
        </a-form-model-item>
        <a-form-model-item
          prop="icon"
          label="病种Icon">
          <a-input placeholder="请输入病种Icon" v-model="model.icon" />
        </a-form-model-item>


        <a-form-model-item prop="name" label="所属科室/亚专业">
          <div class='header'><a-button @click="addDataSource" type="primary" size='small' style='float: right'>添加</a-button>
          </div>
          <div class='list' v-if="this.model.deptSubMajorList">
            <div class='list-item' v-for='(item, index) in this.model.deptSubMajorList'>
              <a-space :size='12'>
                <a-select style='width: 200px' v-model='item.deptId' @change="deptChange(item)"  placeholder='请选择科室' allow-clear showSearch :filterOption="filterOption">
                  <a-select-option :value='item.id' :key="item.id" v-for="item in deptList">{{ item.name}}</a-select-option>
                </a-select>
                <a-select style='width: 200px' v-model='item.submajorId' @change="majorChange(item)"  placeholder='请选择亚专业' allow-clear showSearch :filterOption="filterOption">
                  <a-select-option :value='item.id' :key="item.id" v-for="item in subMajorList">{{ item.name}}</a-select-option>
                </a-select>
                <span><a-icon type="close" @click='removeDataSource(index)' /></span>
              </a-space>
            </div>
          </div>
        </a-form-model-item>


        <a-form-model-item
          prop="keywordList"
          help="输入关键字后，敲击回车键"
          label="关键字">
          <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择' >
            <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{item}}</a-select-option>
          </a-select>
        </a-form-model-item>

<!--        <a-form-model-item-->
<!--          prop="description"-->
<!--          label="所属系统">-->
<!--          <a-input placeholder="请输入所属系统" v-model="model.systemBelong" />-->
<!--        </a-form-model-item>-->

        <a-form-model-item
            prop="description"
          label="描述">
          <a-textarea :rows="4" placeholder="请输入描述" v-model="model.description" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: "TempConfigDiseaseModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {
          deptSubMajorList:[{}],
          keywordList:[],
        },
        rules:{
          name:[baseRules.required],
          relation:[baseRules.requiredChange],
          keywordList:[baseRules.requiredChange],
        },
        confirmLoading: false,
        url: {
          add: "/tempconfig/tempConfigDisease/add",
          edit: "/tempconfig/tempConfigDisease/edit",
        },
        deptList:[],
        subMajorList:[],
        dataSource: [{}],
      }
    },
    created () {
      getAction('/tempconfig/tempConfigDept/listAll').then(res=>{
        if(res.success){
          this.deptList = res.result
        }
      })
    },
    methods: {
      keywordChange(){
        this.$set(this.model,'keyword',this.model.keywordList.join(','))
      },
      add () {
        this.edit({
          keywordList:[],
        });
      },
      edit (record) {
        if(record&&record.deptSubMajorList) {
          for (const item of record.deptSubMajorList) {
            this.deptChange(item)
            this.majorChange(item)
          }
        }
        this.model = Object.assign({
          deptSubMajorList:record.deptSubMajorList?record.deptSubMajorList:[],
          keywordList:record.keyword?record.keyword.split(','):[]
        }, record);

        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleCancel () {
        this.close()
      },
      /**
       * 添加数据源
       */
      addDataSource() {
        const dataSource2 = this.model.deptSubMajorList || []
        dataSource2.push({})
        this.$set(this.model, 'deptSubMajorList', dataSource2)
      },

      deptChange(item) {
        const field = this.deptList.filter(field => field.id === item.deptId)[0]
        if (field) {
          item.name = `${field.name}`
        }
        getAction('/tempconfig/tempConfigSubmajor/queryByDeptId',{id:item.deptId}).then(res=>{
          if(res.success){
            this.subMajorList = res.result
          }
        })
      },
      majorChange(item) {
        const field = this.subMajorList.filter(field => field.id === item.id)[0]
        if (field) {
          item.name = `${field.name}`
          item.submajorid=field.id
        }
      },
      /**
       * 移除数据源
       * @param key
       * @param index
       */
      removeDataSource(index) {
        //this.model.deptSelectList.splice(index, 1)
        this.model.deptSubMajorList.splice(index, 1)
      },
    }
  }
</script>

<style lang="less" scoped>

</style>